import React from "react";
import "./Skills.scss";

const Skills = () => {
    return (
        <section className="skills" id="skills">
            <h6>LEVEL OF KNOWLEDGE</h6>
            <h1>MY SKILLS</h1>
            <div className="skills__details">
                <div className="skills__details--col">
                    <div className="skills__details--col-row">
                        <h2>Back-End Technology</h2>
                        <div className="skill">
                            <img src="./images/skill/node.png" alt="icon" />
                            <p>NodeJS</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/express.png" alt="icon" />
                            <p>ExpressJS</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/graph.png" alt="icon" />
                            <p>GraphQL</p>
                        </div>
                    </div>
                    <div className="skills__details--col-row">
                        <h2>Front-End Technology</h2>
                        <div className="skill">
                            <img src="./images/skill/react.png" alt="icon" />
                            <p>ReactJS</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/next.png" alt="icon" />
                            <p>NextJs</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/redux.png" alt="icon" />
                            <p>Redux</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/sass.png" alt="icon" />
                            <p>SCSS/SASS</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/css.png" alt="icon" />
                            <p>CSS</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/html.png" alt="icon" />
                            <p>HTML</p>
                        </div>
                    </div>
                </div>
                <div className="skills__details--col">
                    <div className="skills__details--col-row">
                        <h2>Database Technology</h2>
                        <div className="skill">
                            <img src="./images/skill/mongodb.png" alt="icon" />
                            <p>MongoDB</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/mysql.png" alt="icon" />
                            <p>MySQL</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/firebase.png" alt="icon" />
                            <p>Firebase</p>
                        </div>
                    </div>
                    <div className="skills__details--col-row">
                        <h2>Other Technology</h2>
                        <div className="skill">
                            <img src="./images/skill/js.png" alt="icon" />
                            <p>Javascript</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/cpp.png" alt="icon" />
                            <p>C++</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/git.png" alt="icon" />
                            <p>Git</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/netlify.png" alt="icon" />
                            <p>Netlity</p>
                        </div>
                        <div className="skill">
                            <img src="./images/skill/heroku.png" alt="icon" />
                            <p>Heroku</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;
